import Header from "../Header/Header";
import {Link} from "react-router-dom";

export default function StartPage() {

	return (
		<>
			<Header />
			<Link to='/bildgalleri'>Bildgalleri</Link>
		</>
	);
}
